import React from 'react';
import { Form } from 'react-bootstrap';
import { Field as FormikField, useField } from 'formik';
import { FormField } from '../../../types/general';
import * as FieldsProps from '../../../types/fields';
import './Input.scss';

export type Props = FormField;

/**
 * Generic input type
 */
const Checkbox: React.FC<Props> = (props) => {
	const { schema } = props;
	const { name, label, props: fieldProps } = schema;
	const { readonly, disabled } = (fieldProps as FieldsProps.Input) || {};
	const [field, meta, helpers] = useField(name);

	const { value } = field;
	const { error } = meta;
	const { setValue } = helpers;

	return (
		<div key={`field-${name}`} className='Field-checkbox'>
			<Form.Group controlId={name}>
				<Form.Check
					label={label}
					type='checkbox'
					checked={value}
					onChange={(e) => setValue(e.target.checked)}
					isInvalid={!!error}
					readOnly={readonly}
					disabled={disabled}
				/>
			</Form.Group>
		</div>
	);
};

export default Checkbox;
